import { create } from "zustand";

export interface AIPanelState {
  isOpen: boolean;
  open(): void;
  close(): void;
}

export const useAIPanelStore = create<AIPanelState>((set) => {
  return {
    isOpen: false,
    open: () =>
      set(() => ({
        isOpen: true,
      })),

    close: () =>
      set(() => ({
        isOpen: false,
      })),
  };
});
